import { useFormContext } from "react-hook-form";
import Langs from "../../utils/data/langs.json";
import countries from "../../utils/data/countries.json";
import { FilterSelectInput, FilterNumberInput } from "./filters";

const SearchTutorBar = ({ handleSearch }) => {
    const { register, control, errors } = useFormContext();

    const languages = Langs.map((lang) => ({
        value: lang.value,
        label: `${lang.name} — ${lang.nativeName}`,
    }));

    const countryOptions = countries.map((country) => ({
        value: country.iso,
        label: country.name,
    }));

    const triggerSearch = () => handleSearch(0);

    return (
        <div className="grid grid-cols-1 gap-4 md:grid-cols-2 xl:grid-cols-4">
            <FilterSelectInput
                name="teach"
                label="I want to learn"
                placeholder="Any language"
                options={languages}
                control={control}
                errors={errors}
                onChangeSelect={triggerSearch}
                isSearchable
                isClearable
            />
            <FilterSelectInput
                name="speak"
                label="I speak"
                placeholder="Any language"
                options={languages}
                control={control}
                errors={errors}
                onChangeSelect={triggerSearch}
                isClearable
            />
            <FilterSelectInput
                name="country"
                label="Country"
                placeholder="Any country"
                options={countryOptions}
                control={control}
                errors={errors}
                onChangeSelect={triggerSearch}
                isSearchable
                isClearable
            />
            <FilterNumberInput
                name="price"
                label="Max price (€)"
                placeholder="Any price"
                register={register}
                errors={errors}
                onChange={triggerSearch}
            />
        </div>
    );
};

export { SearchTutorBar };
